export default __webpack_public_path__ + "static/professional-training-why-us-e6929cc9fe71fa4aa0c23eb64e52f801.png";